module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commentBox",
    class: {
      personalNote: _vm.commentIsNote
    }
  }, [_c('div', {
    staticClass: "title",
    style: ({
      color: [_vm.commentIsNote ? '' : _vm.colorClient]
    })
  }, [_vm._v("\n        " + _vm._s(_vm.commentTitle) + " "), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.comment.createdAt))])]), _vm._v(" "), _c('div', {
    staticClass: "commentContent"
  }, [(_vm.comment.isPersonal === false && _vm.comment.commentStatus.id !== 1) ? _c('span', {
    staticClass: "checkImg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/tick.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.comment.content))])]), _vm._v(" "), (_vm.commentIsNote) ? _c('div', {
    staticClass: "commentButton"
  }, [_c('button', {
    on: {
      "click": _vm.removePersonalNote
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.removePersonalNote")))])]) : _c('div', {
    staticClass: "commentAction"
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.toggleRepliesBloc
    }
  }, [(_vm.repliesBlocIsOpened) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v("+")]), _vm._v(" " + _vm._s(_vm.$t("commentPanel.reply")) + "\n        ")]), _vm._v(" "), (_vm.haveRights) ? _c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.statusSwitcher
    }
  }, [_vm._v(_vm._s(_vm.resolved))]) : _vm._e(), _vm._v(" "), (_vm.haveRights) ? _c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.InPdfSwitcher
    }
  }, [_vm._v(_vm._s(_vm.inPdf))]) : _vm._e()]), _vm._v(" "), (_vm.comment.isPersonal === false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.repliesBlocIsOpened),
      expression: "repliesBlocIsOpened"
    }],
    staticClass: "replies"
  }, [_vm._l((_vm.subComments), function(subComment) {
    return _c('div', {
      key: subComment.id,
      staticClass: "sub-comment"
    }, [_c('p', [_c('span', {
      staticClass: "ff-bold senderComment"
    }, [_vm._v(_vm._s(subComment.createdUser.initial))]), _vm._v(" " + _vm._s(subComment.content) + "\n            ")])])
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subNewCommentField),
      expression: "subNewCommentField"
    }],
    staticClass: "newComment",
    attrs: {
      "placeholder": _vm.$t('commentPanel.replySubCommentPh')
    },
    domProps: {
      "value": (_vm.subNewCommentField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subNewCommentField = $event.target.value
      }
    }
  }), _vm._v(" "), _c('RoundedButton', {
    attrs: {
      "disabled": !_vm.canSaveReply
    },
    on: {
      "click": _vm.sendReply
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("commentPanel.replyButton")) + " ")])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e387cdf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentBloc/CommentBox.vue
// module id = 3385
// module chunks = 0